import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetDeviceVersionList() {
  return maintainRequest({
    url: `/device/deviceType/getAllDeviceType`,
  });
}
